// ScrollableContent component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDom from 'react-dom'
import $ from 'jquery'

class ScrollableContent extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isScrolling: false
    }

    this.data = {
      prevStartDate: null
    }
  }

  static get propTypes () {
    return {
      className: PropTypes.string,
      children: PropTypes.any,
      style: PropTypes.object,
      positionLeft: PropTypes.number,
      activeDate: PropTypes.object,
      activeIndex: PropTypes.number,
      startDate: PropTypes.object,
      onReachLeft: PropTypes.func,
      onReachRight: PropTypes.func,
      getPositionLeftByDate: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      className: '',
      children: null,
      style: {},
      positionLeft: 0,
      activeDate: null,
      activeIndex: 0,
      startDate: null,
      onReachLeft: null,
      onReachRight: null,
      getPositionLeftByDate: null
    }
  }

  componentDidMount () {
    this._scroller.scrollLeft = this.props.positionLeft
  }

  componentDidUpdate (prevProps) {
    if (prevProps.activeDate !== this.props.activeDate) {
      // this._scroller.scrollLeft = this.props.positionLeft;
      $(this._scroller).animate({ scrollLeft: this.props.positionLeft }, 200)
    } else if (this.data.prevStartDate) {
      const scrollLeft = this.props.getPositionLeftByDate(
        this.data.prevStartDate
      )
      if (scrollLeft !== null) {
        this._scroller.scrollLeft = scrollLeft
      }
    } else if (prevProps.activeIndex !== this.props.activeIndex) {
      this._scroller.scrollLeft = this.props.positionLeft
    }
  }

  render () {
    const { className, children, style } = this.props

    return (
      <div
        className='scrollable-wrap'
        ref={this._attachScroller.bind(this)}
        onScroll={this._onMouseMove.bind(this)}
      >
        <div
          className={`scrollable-content${className ? ' ' + className : ''}`}
          style={style || {}}
        >
          {children}
        </div>
      </div>
    )
  }

  _onMouseMove (_event) {
    this._handleHorizontalScroll()
  }

  _attachScroller (scroller) {
    this._scroller = ReactDom.findDOMNode(scroller)
  }

  _handleHorizontalScroll () {
    const {
      firstChild,
      lastChild,
      scrollLeft,
      offsetLeft,
      offsetWidth
    } = this._scroller

    const { onReachRight, onReachLeft } = this.props

    const leftEdge = firstChild.offsetLeft
    const rightEdge = lastChild.offsetLeft + lastChild.offsetWidth - 1
    const scrolledLeft = scrollLeft + offsetLeft
    const scrolledRight = scrolledLeft + offsetWidth

    this.data.prevStartDate = null
    if (scrolledRight >= rightEdge) {
      if (onReachRight) {
        onReachRight()
      }
    } else if (scrolledLeft <= leftEdge) {
      this.data.prevStartDate = this.props.startDate
      if (onReachLeft) {
        onReachLeft()
      }
    }
  }
}

export default ScrollableContent
